import Image from "next/legacy/image";
import React from "react";
import WhatAppIcon from "public/assets/whatsappicon.png";
import {
  PriceListWrapper,
  PriceListContent,
  PriceListTitle,
  PriceListSubtitle,
  PriceGrid,
  PriceCard,
  PriceCardHead,
  PriceRow,
  PriceRowPlan,
  PriceRowPlanName,
  PriceRowPlanDesc,
  PriceRowAmount,
  PriceRowPrice,
  PriceRowPeriod,
  PriceCardNote,
  PriceListCTAWrap,
  PriceListCTAButton
} from "./price-list-section.styles";

interface PricePlan {
  name: string;
  description: string;
  price: string;
}

interface PriceCardData {
  title: string;
  plans: PricePlan[];
  bgColor?: string;
  note?: string;
}

const priceCards: PriceCardData[] = [
  {
    title: "SD",
    plans: [
      { name: "1x Seminggu", description: "kelas MTK", price: "Rp90.000" },
      { name: "2x Seminggu", description: "kelas MTK", price: "Rp170.000" },
      {
        name: "Tambahan IPA",
        description: "1x seminggu (kelas 5-6)",
        price: "+Rp80.000"
      }
    ]
  },
  {
    title: "SMP",
    plans: [
      { name: "1x Seminggu", description: "kelas MTK", price: "Rp90.000" },
      { name: "2x Seminggu", description: "kelas MTK", price: "Rp170.000" },
      { name: "Tambahan IPA", description: "1x seminggu", price: "+Rp80.000" }
    ]
  },
  {
    title: "SMA 10–11",
    plans: [
      { name: "1x Seminggu", description: "kelas MTK", price: "Rp90.000" },
      { name: "2x Seminggu", description: "kelas MTK", price: "Rp170.000" },
      {
        name: "Tambahan IPA/Fis/Kim",
        description: "1x seminggu",
        price: "+Rp80.000"
      }
    ]
  },
  {
    title: "SMA 12",
    bgColor: "#0f32b1",
    plans: [
      {
        name: "4 kelas/minggu",
        description: "2x TKA MTK ·\n1x TKA Fisika\n1x TKA Kimia",
        price: "Rp170.000"
      }
    ],
    note: "*khusus untuk kelas 12, anak tidak mendapatkan teman sekelas yang sama dan tidak mendapatkan laporan belajar."
  }
];

interface PriceListSectionProps {
  onCTAClick?: () => void;
}

export const PriceListSection: React.FC<PriceListSectionProps> = ({
  onCTAClick
}) => {
  const handleCTAClick = () => {
    if (onCTAClick) {
      onCTAClick();
    } else {
      window.location.href =
        "https://api.whatsapp.com/send/?phone=6281919187201&text=Halo%2C+saya+minta+%23info+bimbel+online+Matematika+di+CoLearn&type=phone_number&app_absent=0";
    }
  };

  return (
    <PriceListWrapper>
      <PriceListContent>
        <PriceListTitle>Paket Belajar 2026/2027</PriceListTitle>
        <PriceListSubtitle>
          Semua paket sudah termasuk Kelas Live + Latihan Mingguan + Laporan
          Belajar.
        </PriceListSubtitle>
        <PriceGrid>
          {priceCards.map((card) => (
            <PriceCard key={card.title} $bgColor={card.bgColor}>
              <PriceCardHead>{card.title}</PriceCardHead>
              {card.plans.map((plan) => (
                <PriceRow key={plan.name + plan.price}>
                  <PriceRowPlan>
                    <PriceRowPlanName>{plan.name}</PriceRowPlanName>
                    <PriceRowPlanDesc>{plan.description}</PriceRowPlanDesc>
                  </PriceRowPlan>
                  <PriceRowAmount>
                    <PriceRowPrice>{plan.price}</PriceRowPrice>
                    <PriceRowPeriod>/bulan</PriceRowPeriod>
                  </PriceRowAmount>
                </PriceRow>
              ))}
              {card.note && <PriceCardNote>{card.note}</PriceCardNote>}
            </PriceCard>
          ))}
        </PriceGrid>
        <PriceListCTAWrap>
          <PriceListCTAButton onClick={handleCTAClick}>
            <span>Minta info bimbel</span>
            <Image
              src={WhatAppIcon}
              alt="WhatsApp"
              width={20}
              height={20}
              layout="fixed"
            />
          </PriceListCTAButton>
        </PriceListCTAWrap>
      </PriceListContent>
    </PriceListWrapper>
  );
};
